<template>
  <div class="examineBox">
    <div class="containter" v-loading='loading' style="margin-top:10px">
      <div class="topOperation clear">
        <span class="title">开票信息修改记录</span>
        <div style="float:right">
          <label class="label_name">类型筛选：</label>
          <el-select v-model="type" @change="init(1)" style="width:100px;margin-right:60px" size="small" placeholder="开票状态">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-input placeholder="请输入客户全称" v-model.trim="customer_name" clearable @keydown.enter.native="customer_name?init(1):''" @clear="init(1)" size="small" style="width:260px">
            <el-button slot="append" icon="el-icon-search" @click="customer_name?init(1):''" style="padding:0 10px"></el-button>
          </el-input>
        </div>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 211px)" border>
          <el-table-column prop="customer_name" label="客户名称" align='center' width='240'></el-table-column>
          <el-table-column prop="before_data" align='center' label="修改前数据">
            <template slot-scope="props">
              <div>
                <p class="dataInfoItem"><span>税号：</span>{{ props.row.before_data.party_a_ein }}</p>
                <p class="dataInfoItem"><span>银行/账户：</span>{{ props.row.before_data.party_a_account }}</p>
                <p class="dataInfoItem"><span>地址/电话：</span>{{ props.row.before_data.party_a_address }}</p>
                <p class="dataInfoItem"><span>发票类型：</span>{{ props.row.before_data.service_type }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="after_data" align='center' label="修改后数据">
            <template slot-scope="props">
              <div>
                <p class="dataInfoItem"><span>税号：</span>{{ props.row.after_data.party_a_ein }}</p>
                <p class="dataInfoItem"><span>银行/账户：</span>{{ props.row.after_data.party_a_account }}</p>
                <p class="dataInfoItem"><span>地址/电话：</span>{{ props.row.after_data.party_a_address }}</p>
                <p class="dataInfoItem"><span>发票类型：</span>{{ props.row.after_data.service_type }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="op_user_name" align='center' label="操作人" width="120"></el-table-column>
          <el-table-column prop="created_at" align='center' label="操作时间" width="150"></el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      accountList: [],
      customer_name: '',
      userInfo: {},
      type: '',
      typeList: [
        { id: '', name: '全部' },
        { id: 1, name: '客户全称' },
        { id: 2, name: 'mcn机构' },
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.init(1)
  },
  mounted () {
  },
  methods: {
    handleCurrentChange (val) {
      this.init(val)
    },
    init (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.customerInvoiceInformationUpdateRecordsList, {
        params: {
          page: page,
          page_size: this.page_size,
          customer_name: this.customer_name,
          type: this.type
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.dataInfoItem {
  text-align: left;
  padding: 2px 0;
  span {
    color: #99a9bf;
  }
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    .topOperation {
      padding: 16px;
      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
}
.label_name {
  font-size: 13px;
  margin-left: 8px;
  line-height: 30px;
}
</style>
<style lang="scss">
.el-date-editor .el-range-separator {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/invoiceModifyRecord.vue